import { logoInputs } from "@/components/Logo/inputs/logoInputs.builder";

const navLinkInputs = [
  {
    name: "title",
    type: "string",
    required: true,
  },
  {
    name: "url",
    type: "url",
    required: true,
  },
  {
    name: "isActive",
    type: "boolean",
  },
] as const satisfies Inputs;

export const footerInputs = [
  {
    name: "logoProps",
    type: "object",
    required: true,
    subFields: logoInputs,
  },
  {
    name: "footerNavProps",
    type: "object",
    required: true,
    subFields: [
      {
        name: "subNavs",
        type: "list",
        required: true,
        subFields: [
          {
            name: "title",
            type: "string",
            required: true,
            defaultValue: "",
          },
          {
            name: "links",
            type: "list",
            required: true,
            defaultValue: [],
            subFields: navLinkInputs,
          },
        ],
      },
      {
        name: "subNavsInlineEndSection",
        type: "object",
        subFields: [
          { name: "title", type: "string", required: true },
          {
            name: "links",
            type: "list",
            required: true,
            subFields: navLinkInputs,
            defaultValue: [],
          },
        ],
      },
    ],
    defaultValue: {
      subNavs: [],
    },
  },
  {
    name: "copyrightProps",
    type: "object",
    required: true,
    subFields: [
      {
        name: "enableCookieSettings",
        type: "boolean",
        required: true,
      },
      {
        name: "copyright",
        type: "string",
        required: true,
      },
      {
        name: "isCurrentYearAppended",
        type: "boolean",
        friendlyName: "Append current year to the copyright",
      },
      {
        name: "links",
        type: "list",
        subFields: navLinkInputs,
        required: true,
      },
    ],
    defaultValue: {
      copyright: "",
      links: [],
      isCurrentYearAppended: true,
      enableCookieSettings: false,
    },
  },
  {
    name: "socialIcons",
    type: "list",
    subFields: [
      {
        name: "alt",
        type: "string",
        required: true,
      },
      {
        name: "icon",
        type: "file",
        allowedFileTypes: ["svg", "jpg", "png", "gif", "jpeg"],
        required: true,
      },
      {
        name: "link",
        type: "url",
        required: true,
      },
    ],
    defaultValue: [
      {
        alt: "Youtube",
        icon: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F76b294f295d44040858a9536eaa439a9",
        link: "https://youtube.com",
      },
      {
        alt: "Facebook",
        icon: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fbdacad29a20d416487e9d99a0d0940d7",
        link: "https://facebook.com",
      },
      {
        alt: "Instagram",
        icon: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F63665a06a3e7425ab84d4b2b5d8edfa9",
        link: "https://instagram.com",
      },
    ],
  },
  {
    name: "paymentIcons",
    type: "list",
    subFields: [
      {
        name: "alt",
        type: "string",
        required: true,
      },
      {
        name: "icon",
        type: "file",
        required: true,
        allowedFileTypes: ["svg", "jpg", "png", "gif", "jpeg"],
      },
      {
        name: "href",
        type: "url",
      },
    ],
    defaultValue: [
      {
        alt: "Visa",
        icon: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F723c8d4e57704e858082b6ba1d7f5e21",
      },
      {
        alt: "Mastercard",
        icon: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F9c258ff6e45b48dca54c2a326b8f8a50",
      },
      {
        alt: "Klarna",
        icon: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fb52247ea2ded478c860ae2d7e2f72002",
      },
    ],
  },
  {
    name: "healthBannerProps",
    type: "object",
    subFields: [
      {
        name: "content",
        type: "richText",
        defaultValue: "",
      },
      {
        name: "variant",
        type: "string",
        enum: ["default", "strong", "stronger"],
        defaultValue: "strong",
      },
    ],
  },
  {
    name: "isExtended",
    type: "boolean",
    required: true,
    defaultValue: false,
  },
  {
    name: "enableFooterBottomZone",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "firstEditingZone",
    type: "blocks",
    hideFromUI: true,
    defaultValue: [],
  },
  {
    name: "secondEditingZone",
    type: "blocks",
    hideFromUI: true,
    defaultValue: [],
  },
  {
    name: "enableFooterTopZone",
    type: "boolean",
    required: true,
    defaultValue: false,
  },
  {
    name: "topEditingZone",
    type: "blocks",
    hideFromUI: true,
    defaultValue: [],
  },
  {
    name: "enableTopBanner",
    type: "boolean",
  },
  {
    name: "topBannerEditingZone",
    type: "blocks",
    hideFromUI: true,
    defaultValue: [],
  },
  {
    name: "withListComponent",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "theme",
    type: "string",
    enum: ["light", "dark"],
    defaultValue: "dark",
  },
] as const satisfies Inputs;

export type FooterProps = BuilderComponentProps<typeof footerInputs>;
